// import React, { useState, useEffect } from "react";
// import PropTypes from "prop-types";
// import SoftBox from "components/SoftBox";
// import SoftTypography from "components/SoftTypography";
// import SoftInput from "components/SoftInput";
// import SoftButton from "components/SoftButton";
// import SoftSnackbar from "components/SoftSnackbar";
// import SoftSelect from "components/SoftSelect";
// import { API_URL } from "config";
// import { Card } from "@mui/material";
// import {
//     fetchBranches,
//     fetchShifts,
//     fetchDepartments,
//     fetchDesignations,
//     fetchRoles,
// } from "api/interviewuserdata";
// import { getUsers } from "api/users";

// const initialForm = {
//     leave_name: "",
//     leave_code: "",
//     leave_category: "",
//     leave_type: "",
//     leave_credit_unit: "",
//     leave_credit_days: 0,
//     leave_reset_cycle: "",
//     leave_description: "",
//     leave_rules: {
//         visibility: {
//             start_anchor: "",
//             start_after_days: "",
//             start_after_months: 0,
//         },
//         accrual: {
//             pattern: "",
//             frequency: "",
//             k: null,
//             phase: 0,
//             day: 23,
//             credits_per_event: 1,
//             credits_per_month: 1,
//             max_cap_per_year: null,
//         },
//         max_cap_per_year: 6,
//         carry_forward: {
//             enabled: false,
//             max_cap_per_year: 0,
//         },
//         reset: { mode: "", date: "" },
//     },
//     selectors: [{ mode: "include", selector_type: "branch", values: ["ALL"] }],
// };

// // Custom styles for all SoftSelect components
// const customSelectStyles = {
//     menu: (provided) => ({
//         ...provided,
//         zIndex: 9999,
//     }),
//     menuPortal: (provided) => ({
//         ...provided,
//         zIndex: 9999,
//     }),
//     container: (provided) => ({
//         ...provided,
//         zIndex: 9998,
//     }),
//     control: (provided) => ({
//         ...provided,
//         zIndex: 1,
//     }),
// };

// export default function CreateLeavePolicyForm({ policyId, onSuccess, onCancel }) {
//     const [form, setForm] = useState(initialForm);
//     const [loading, setLoading] = useState(false);
//     const [snack, setSnack] = useState({ open: false, color: "success", message: "" });
//     const [errors, setErrors] = useState(null);
//     const [created, setCreated] = useState(null);

//     // API Data States
//     const [branches, setBranches] = useState([]);
//     const [shifts, setShifts] = useState([]);
//     const [departments, setDepartments] = useState([]);
//     const [designations, setDesignations] = useState([]);
//     const [roles, setRoles] = useState([]);
//     const [users, setUsers] = useState([]);

//     // Filtered Data States
//     const [filteredShifts, setFilteredShifts] = useState([]);
//     const [filteredDepartments, setFilteredDepartments] = useState([]);
//     const [filteredDesignations, setFilteredDesignations] = useState([]);
//     const [filteredUsers, setFilteredUsers] = useState([]);

//     // Mode state
//     const [isEditMode, setIsEditMode] = useState(false);

//     // Pagination state for users
//     const [userPagination, setUserPagination] = useState({
//         currentPage: 1,
//         totalPages: 1,
//         totalUsers: 0,
//         perPage: 1000,
//     });

//     // helper to normalize user lists (handles different API shapes)
//     const normalizeUsersArray = (resp) => {
//         if (!resp) return [];
//         if (Array.isArray(resp)) return resp;
//         if (Array.isArray(resp.data)) return resp.data;
//         if (Array.isArray(resp.users)) return resp.users;
//         if (resp.users && Array.isArray(resp.users.data)) return resp.users.data;
//         if (resp.data && Array.isArray(resp.data.users)) return resp.data.users;
//         return [];
//     };

//     // Convert options for SoftSelect
//     const convertOptionsForSoftSelect = (optionsArray, labels = {}) => {
//         return optionsArray.map((option) => ({
//             value: option,
//             label: labels[option] || option,
//         }));
//     };

//     // Convert selector options for SoftSelect
//     const convertSelectorOptionsForSoftSelect = (optionsArray) => {
//         return optionsArray.map((option) => ({
//             value: option.id,
//             label: option.name,
//         }));
//     };

//     // Fetch policy data when policyId changes
//     useEffect(() => {
//         if (policyId) {
//             setIsEditMode(true);
//             fetchPolicyData(policyId);
//         } else {
//             setIsEditMode(false);
//             setForm(initialForm);
//         }
//     }, [policyId]);

//     // Fetch all initial data
//     useEffect(() => {
//         const loadInitialData = async () => {
//             try {
//                 const [branchesData, shiftsData, deptsData, designationsData, rolesData, usersData] =
//                     await Promise.all([
//                         fetchBranches(),
//                         fetchShifts(),
//                         fetchDepartments(),
//                         fetchDesignations(),
//                         fetchRoles(),
//                         getAllUsers(),
//                     ]);

//                 const normalized = normalizeUsersArray(usersData);
//                 setBranches(Array.isArray(branchesData) ? branchesData : []);
//                 setShifts(Array.isArray(shiftsData) ? shiftsData : []);
//                 setFilteredShifts(Array.isArray(shiftsData) ? shiftsData : []);
//                 setDepartments(Array.isArray(deptsData) ? deptsData : []);
//                 setFilteredDepartments(Array.isArray(deptsData) ? deptsData : []);
//                 setDesignations(Array.isArray(designationsData) ? designationsData : []);
//                 setFilteredDesignations(Array.isArray(designationsData) ? designationsData : []);
//                 setRoles(Array.isArray(rolesData) ? rolesData : []);
//                 setUsers(normalized);
//                 setFilteredUsers(normalized);
//             } catch (error) {
//                 console.error("Error loading initial data:", error);
//             }
//         };

//         loadInitialData();
//     }, []);

//     // New function to get all users with pagination
//     const getAllUsers = async () => {
//         try {
//             let allUsers = [];
//             let currentPage = 1;
//             let hasMore = true;
//             const perPage = 1000;

//             while (hasMore) {
//                 const usersData = await getUsers(currentPage, perPage);
//                 const normalized = normalizeUsersArray(usersData);

//                 if (normalized.length > 0) {
//                     allUsers = [...allUsers, ...normalized];
//                     currentPage++;

//                     if (normalized.length < perPage) {
//                         hasMore = false;
//                     }
//                 } else {
//                     hasMore = false;
//                 }
//             }

//             setUserPagination((prev) => ({
//                 ...prev,
//                 totalUsers: allUsers.length,
//                 totalPages: currentPage - 1,
//             }));

//             return allUsers;
//         } catch (error) {
//             console.error("Error fetching all users:", error);
//             return [];
//         }
//     };

//     const fetchWithAuth = async (url, options = {}) => {
//         const token = localStorage.getItem("authToken");
//         const res = await fetch(url, {
//             ...options,
//             headers: {
//                 ...(options.headers || {}),
//                 Authorization: `Bearer ${token}`,
//                 "Content-Type": "application/json",
//                 Accept: "application/json",
//             },
//         });
//         const data = await res.json().catch(() => ({}));
//         if (!res.ok) {
//             throw { status: res.status, data };
//         }
//         return data;
//     };

//     // Fetch policy data by ID
//     const fetchPolicyData = async (id) => {
//         setLoading(true);
//         try {
//             const data = await fetchWithAuth(`${API_URL}/leave-policies/${id}`);

//             // Defensive merge: ensure leave_rules has all expected nested keys
//             const mergeDeep = (target, source) => {
//                 const out = Array.isArray(target) ? [...target] : { ...target };
//                 if (!source || typeof source !== "object") return out;
//                 Object.keys(source).forEach((k) => {
//                     if (
//                         source[k] &&
//                         typeof source[k] === "object" &&
//                         !Array.isArray(source[k]) &&
//                         out[k] &&
//                         typeof out[k] === "object"
//                     ) {
//                         out[k] = mergeDeep(out[k], source[k]);
//                     } else {
//                         out[k] = source[k];
//                     }
//                 });
//                 return out;
//             };

//             // Normalize server leave_rules shape (handles older/newer API shapes)
//             const serverRules = data.leave_rules || {};

//             // Build accrual by checking both `accrual` and legacy placements under `visibility`
//             const accrualFromVisibility = {};
//             if (serverRules.visibility) {
//                 if (serverRules.visibility.credit_per_event != null)
//                     accrualFromVisibility.credits_per_event = serverRules.visibility.credit_per_event;
//                 if (serverRules.visibility.credits_per_event != null)
//                     accrualFromVisibility.credits_per_event = serverRules.visibility.credits_per_event;
//                 if (serverRules.visibility.credit_per_month != null)
//                     accrualFromVisibility.credits_per_month = serverRules.visibility.credit_per_month;
//                 if (serverRules.visibility.credits_per_month != null)
//                     accrualFromVisibility.credits_per_month = serverRules.visibility.credits_per_month;
//                 // map other visibility-based accrual-like fields
//                 if (serverRules.visibility.max_events_per_year != null)
//                     accrualFromVisibility.max_events_per_year = serverRules.visibility.max_events_per_year;
//                 if (serverRules.visibility.next_event_after_days != null)
//                     accrualFromVisibility.next_event_after_days = serverRules.visibility.next_event_after_days;
//             }

//             const accrualProvided = serverRules.accrual && Object.keys(serverRules.accrual).length > 0;
//             const accrualPatternDefault = accrualProvided
//                 ? serverRules.accrual.pattern || initialForm.leave_rules.accrual.pattern
//                 : Object.keys(accrualFromVisibility).length > 0
//                     ? "monthly_dayofmonth"
//                     : initialForm.leave_rules.accrual.pattern;

//             const normalizedRules = {
//                 visibility: serverRules.visibility || initialForm.leave_rules.visibility,
//                 accrual: {
//                     ...initialForm.leave_rules.accrual,
//                     ...(serverRules.accrual || {}),
//                     ...accrualFromVisibility,
//                     pattern: accrualPatternDefault,
//                 },
//                 // yearly limits from some APIs are nested under `yearly_limits` — map them
//                 max_cap_per_year:
//                     serverRules.max_cap_per_year ?? serverRules.yearly_limits?.max_cap_per_year ?? initialForm.leave_rules.max_cap_per_year,
//                 carry_forward: serverRules.carry_forward || {
//                     enabled: serverRules.yearly_limits?.carry_forward_enabled ?? initialForm.leave_rules.carry_forward.enabled,
//                     max_cap_per_year: serverRules.yearly_limits?.carry_forward_max ?? initialForm.leave_rules.carry_forward.max_cap_per_year,
//                 },
//                 reset: serverRules.reset || serverRules.yearly_limits?.reset || initialForm.leave_rules.reset,
//             };

//             const mergedLeaveRules = mergeDeep(initialForm.leave_rules, normalizedRules);
//             console.debug("[AddLeavePolicy] mergedLeaveRules:", mergedLeaveRules);

//             const transformedData = {
//                 leave_name: data.leave_name || "",
//                 leave_code: data.leave_code || "",
//                 leave_category: data.leave_category || "fixed",
//                 leave_type: data.leave_type || "paid",
//                 leave_credit_unit: data.leave_credit_unit || "monthly",
//                 leave_credit_days: data.leave_credit_days || 0,
//                 leave_reset_cycle: data.leave_reset_cycle || "yearly",
//                 leave_description: data.leave_description || "",
//                 leave_rules: mergedLeaveRules,
//                 selectors: data.selectors || initialForm.selectors,
//             };

//             setForm(transformedData);

//             if (data.selectors && data.selectors.length > 0) {
//                 fetchUsersBySelectors(data.selectors).catch(() => { });
//             }

//             setSnack({ open: true, color: "success", message: "Policy data loaded successfully." });
//         } catch (error) {
//             console.error("Error fetching policy data:", error);
//             setSnack({ open: true, color: "error", message: "Failed to load policy data." });
//         } finally {
//             setLoading(false);
//         }
//     };

//     // New helper: fetch shifts for a given branch id from server
//     const fetchShiftsByBranch = async (branchId) => {
//         if (!branchId || branchId === "ALL") {
//             setFilteredShifts(Array.isArray(shifts) ? shifts : []);
//             return;
//         }
//         try {
//             const data = await fetchWithAuth(
//                 `${API_URL}/shifts?branch_id=${encodeURIComponent(branchId)}`
//             );
//             const arr = Array.isArray(data) ? data : data?.data ?? [];
//             setFilteredShifts(Array.isArray(arr) ? arr : []);
//         } catch (err) {
//             console.error("Error fetching shifts for branch:", err);
//             setFilteredShifts([]);
//         }
//     };

//     // New helper: build query and fetch users filtered by selectors from server
//     const fetchUsersBySelectors = async (selectors) => {
//         try {
//             const params = new URLSearchParams();
//             const buckets = {
//                 branch: [],
//                 shift: [],
//                 department: [],
//                 designation: [],
//                 role: [],
//                 user: [],
//             };

//             selectors.forEach((s) => {
//                 if (!Array.isArray(s.values)) return;
//                 if (s.values.includes("ALL")) return;
//                 const key = s.selector_type;
//                 if (buckets[key]) {
//                     s.values.forEach((v) => buckets[key].push(String(v)));
//                 }
//             });

//             if (buckets.branch.length) params.append("branch_ids", buckets.branch.join(","));
//             if (buckets.shift.length) params.append("shift_ids", buckets.shift.join(","));
//             if (buckets.department.length) params.append("department_ids", buckets.department.join(","));
//             if (buckets.designation.length)
//                 params.append("designation_ids", buckets.designation.join(","));
//             if (buckets.role.length) params.append("role_ids", buckets.role.join(","));
//             if (buckets.user.length) params.append("user_ids", buckets.user.join(","));

//             params.append("per_page", "1000");

//             const url = `${API_URL}/users?${params.toString()}`;
//             const res = await fetchWithAuth(url);
//             const normalized = normalizeUsersArray(res);
//             setUsers(normalized);
//             setFilteredUsers(normalized);
//         } catch (err) {
//             console.error("Error fetching filtered users:", err);
//             setFilteredUsers([]);
//         }
//     };

//     // Filter shifts by branch (client-side fallback) — kept for compatibility
//     const filterShiftsByBranch = (branchId) => {
//         if (branchId === "ALL") {
//             setFilteredShifts(Array.isArray(shifts) ? shifts : []);
//         } else {
//             const filtered = (Array.isArray(shifts) ? shifts : []).filter(
//                 (shift) => shift.branch_id === branchId || shift.branch_id === parseInt(branchId)
//             );
//             setFilteredShifts(filtered);
//         }
//     };

//     // Filter users based on all selected criteria (client-side fallback / immediate UI)
//     const filterUsers = (selectors) => {
//         const usersArray = Array.isArray(users) ? users : [];
//         let filtered = [...usersArray];

//         selectors.forEach((selector) => {
//             if (!Array.isArray(selector.values)) return;
//             if (selector.values.includes("ALL")) return;

//             switch (selector.selector_type) {
//                 case "branch":
//                     filtered = filtered.filter((user) => selector.values.includes(String(user.branch_id)));
//                     break;
//                 case "shift":
//                     filtered = filtered.filter((user) => selector.values.includes(String(user.shift_id)));
//                     break;
//                 case "department":
//                     filtered = filtered.filter((user) =>
//                         selector.values.includes(String(user.department_id))
//                     );
//                     break;
//                 case "designation":
//                     filtered = filtered.filter((user) =>
//                         selector.values.includes(String(user.designation_id))
//                     );
//                     break;
//                 case "role":
//                     filtered = filtered.filter((user) => selector.values.includes(String(user.role_id)));
//                     break;
//                 case "user":
//                     filtered = filtered.filter((user) => selector.values.includes(String(user.id)));
//                     break;
//                 default:
//                     break;
//             }
//         });

//         setFilteredUsers(filtered);
//     };

//     const setPath = (path, value) => {
//         setForm((prev) => {
//             const copy = structuredClone(prev);
//             const keys = path.split(".");
//             let node = copy;
//             for (let i = 0; i < keys.length - 1; i++) {
//                 const k = keys[i];
//                 if (node[k] == null || typeof node[k] !== "object") node[k] = {};
//                 node = node[k];
//             }
//             node[keys.at(-1)] = value;
//             return copy;
//         });
//     };

//     const addSelector = () => {
//         setForm((prev) => ({
//             ...prev,
//             selectors: [...prev.selectors, { mode: "include", selector_type: "branch", values: ["ALL"] }],
//         }));
//     };

//     const removeSelector = (idx) => {
//         setForm((prev) => {
//             const updatedSelectors = prev.selectors.filter((_, i) => i !== idx);
//             fetchUsersBySelectors(updatedSelectors).catch(() => { });
//             return { ...prev, selectors: updatedSelectors };
//         });
//     };

//     // Handle selector changes with API integration
//     const handleSelectorChange = async (idx, field, value) => {
//         const updatedSelectors = [...form.selectors];

//         if (field === "selector_type") {
//             updatedSelectors[idx][field] = value;
//             updatedSelectors[idx].values = ["ALL"];
//         } else if (field === "values") {
//             // Handle SoftSelect multi-value format
//             const selectedValues = Array.isArray(value)
//                 ? value.map((item) => item.value)
//                 : [value?.value] || ["ALL"];

//             updatedSelectors[idx][field] = selectedValues;

//             // If branch values change, update shifts (server call)
//             if (updatedSelectors[idx].selector_type === "branch") {
//                 const branchVal = Array.isArray(selectedValues) ? selectedValues[0] : selectedValues;
//                 await fetchShiftsByBranch(branchVal);
//                 filterShiftsByBranch(branchVal);
//             }
//         } else {
//             updatedSelectors[idx][field] = value;
//         }

//         setForm((prev) => ({
//             ...prev,
//             selectors: updatedSelectors,
//         }));

//         // server-side fetch (authoritative) - don't await UI responsiveness
//         fetchUsersBySelectors(updatedSelectors).catch(() => { });

//         // client-side immediate filter for snappy UI
//         filterUsers(updatedSelectors);
//     };

//     // Get options for selector dropdown (safe guards)
//     const getSelectorOptions = (selectorType, selectorIndex) => {
//         const safeBranches = Array.isArray(branches) ? branches : [];
//         const safeFilteredShifts = Array.isArray(filteredShifts) ? filteredShifts : [];
//         const safeDepartments = Array.isArray(filteredDepartments) ? filteredDepartments : [];
//         const safeDesignations = Array.isArray(filteredDesignations) ? filteredDesignations : [];
//         const safeRoles = Array.isArray(roles) ? roles : [];
//         const safeFilteredUsers = Array.isArray(filteredUsers) ? filteredUsers : [];

//         switch (selectorType) {
//             case "branch":
//                 return [
//                     { id: "ALL", name: "All Branches" },
//                     ...safeBranches.map((b) => ({
//                         id: String(b.id ?? b.branch_id ?? ""),
//                         name: b.name ?? b.branch_name ?? b.branch ?? `Branch ${b.id}`,
//                     })),
//                 ];
//             case "shift":
//                 return [
//                     { id: "ALL", name: "All Shifts" },
//                     ...safeFilteredShifts.map((s) => ({
//                         id: String(s.id ?? s.shift_id ?? ""),
//                         name: s.name ?? s.shift_name ?? `Shift ${s.id}`,
//                     })),
//                 ];
//             case "department":
//                 return [
//                     { id: "ALL", name: "All Departments" },
//                     ...safeDepartments.map((d) => ({
//                         id: String(d.id ?? d.department_id ?? ""),
//                         name: d.name ?? d.department_name ?? `Dept ${d.id}`,
//                     })),
//                 ];
//             case "designation":
//                 return [
//                     { id: "ALL", name: "All Designations" },
//                     ...safeDesignations.map((d) => ({
//                         id: String(d.id ?? d.designation_id ?? ""),
//                         name: d.name ?? d.designation_name ?? `Desig ${d.id}`,
//                     })),
//                 ];
//             case "role":
//                 return [
//                     { id: "ALL", name: "All Roles" },
//                     ...safeRoles.map((r) => ({
//                         id: String(r.id ?? r.role_id ?? ""),
//                         name: r.name ?? r.role_name ?? `Role ${r.id}`,
//                     })),
//                 ];
//             case "user":
//                 return [
//                     { id: "ALL", name: "All Users" },
//                     ...safeFilteredUsers.map((u) => ({
//                         id: String(u.id ?? ""),
//                         name: `${u.first_name ?? u.name ?? ""} ${u.last_name ?? ""}`.trim() || `User ${u.id}`,
//                     })),
//                 ];
//             default:
//                 return [{ id: "ALL", name: "All" }];
//         }
//     };

//     const onSubmit = async (e) => {
//         e.preventDefault();
//         console.log("🔁 Form submission started");

//         setLoading(true);
//         setErrors(null);
//         setCreated(null);

//         const { pattern, frequency, day, credits_per_event, credits_per_month, k } =
//             form.leave_rules.accrual;

//         console.log("📝 Form values:", {
//             pattern,
//             frequency,
//             day,
//             credits_per_event,
//             credits_per_month,
//             k,
//         });

//         // ===== VALIDATION =====
//         if (pattern === "monthly_dayofmonth") {
//             console.log("🔍 Validation for pattern: monthly_dayofmonth");

//             if (!day || day < 1 || day > 31) {
//                 console.warn("⚠️ Invalid day:", day);
//                 setErrors({ "leave_rules.accrual.day": ["Day must be 1–31."] });
//                 setLoading(false);
//                 return;
//             }

//             if (frequency === "every_k_months") {
//                 console.log("🔍 Validation for frequency: every_k_months");

//                 if (!k || k < 1 || k > 12) {
//                     console.warn("⚠️ Invalid k:", k);
//                     setErrors({ "leave_rules.accrual.k": ["k must be 1–12."] });
//                     setLoading(false);
//                     return;
//                 }
//             }

//             if (credits_per_event == null || isNaN(credits_per_event)) {
//                 console.warn("⚠️ Invalid credits_per_event:", credits_per_event);
//                 setErrors({ "leave_rules.accrual.credits_per_event": ["credits_per_event is required."] });
//                 setLoading(false);
//                 return;
//             }
//         }

//         if (pattern === "monthly_fixed") {
//             console.log("🔍 Validation for pattern: monthly_fixed");

//             if (credits_per_month == null || isNaN(credits_per_month)) {
//                 console.warn("⚠️ Invalid credits_per_month:", credits_per_month);
//                 setErrors({ "leave_rules.accrual.credits_per_month": ["credits_per_month is required."] });
//                 setLoading(false);
//                 return;
//             }
//         }

//         // ===== API CALL =====
//         try {
//             let data;

//             if (isEditMode) {
//                 console.log("✏️ Editing mode. Sending PUT request...");
//                 data = await fetchWithAuth(`${API_URL}/leave-policies/${policyId}`, {
//                     method: "PUT",
//                     body: JSON.stringify(form),
//                 });
//                 console.log("✅ Update response:", data);
//                 setSnack({ open: true, color: "success", message: "Leave policy updated successfully." });
//             } else {
//                 console.log("🆕 Create mode. Sending POST request...");
//                 data = await fetchWithAuth(`${API_URL}/leave-policies`, {
//                     method: "POST",
//                     body: JSON.stringify(form),
//                 });
//                 console.log("✅ Create response:", data);
//                 setSnack({ open: true, color: "success", message: "Leave policy created successfully." });
//             }

//             setCreated(data);

//             if (onSuccess) {
//                 console.log("🔔 Calling onSuccess callback");
//                 onSuccess(data);
//             }
//         } catch (err) {
//             console.error("❌ API request failed:", err);
//             const errs = err?.data?.errors || { _error: [err?.data?.message || "Request failed"] };
//             setErrors(errs);
//             setSnack({
//                 open: true,
//                 color: "error",
//                 message: isEditMode ? "Update failed. Check fields." : "Validation failed. Check fields.",
//             });
//         } finally {
//             console.log("🛑 Form submission completed");
//             setLoading(false);
//         }
//     };

//     const handleReset = () => {
//         if (isEditMode) {
//             fetchPolicyData(policyId);
//         } else {
//             setForm(initialForm);
//         }
//         setErrors(null);
//         setCreated(null);
//     };

//     const handleCancel = () => {
//         if (onCancel) {
//             onCancel();
//         }
//     };

//     const Err = ({ name }) =>
//         errors?.[name] ? (
//             <div className="text-danger small mt-1">
//                 {errors[name].map((m, i) => (
//                     <div key={i}>• {m}</div>
//                 ))}
//             </div>
//         ) : null;
//     Err.propTypes = { name: PropTypes.string.isRequired };

//     return (
//         <Card className="p-3 mb-3 bg-light">
//             <SoftTypography variant="h5" fontWeight="medium" className="mb-3">
//                 {isEditMode ? "Edit Leave Policy" : "Create Leave Policy"}
//             </SoftTypography>

//             <SoftSnackbar
//                 color={snack.color}
//                 icon="notifications"
//                 title="Leave Policy"
//                 content={snack.message}
//                 open={snack.open}
//                 close={() => setSnack({ ...snack, open: false })}
//                 time={3000}
//             />

//             <SoftBox component="form" onSubmit={onSubmit} autoComplete="off" noValidate>
//                 {/* BASIC INFORMATION - 2 fields per row */}
//                 <Section title="Basic Information">
//                     <TwoColumnRow>
//                         <Field label="Leave Name">
//                             <SoftInput
//                                 name="leave_name"
//                                 value={form.leave_name}
//                                 onChange={(e) => setPath("leave_name", e.target.value)}
//                                 required
//                             />
//                             <Err name="leave_name" />
//                         </Field>

//                         <Field label="Leave Code">
//                             <SoftInput
//                                 name="leave_code"
//                                 value={form.leave_code}
//                                 onChange={(e) => setPath("leave_code", e.target.value)}
//                                 required
//                             />
//                             <Err name="leave_code" />
//                         </Field>
//                     </TwoColumnRow>

//                     <TwoColumnRow>
//                         <Field label="Category">
//                             <SoftSelect
//                                 styles={customSelectStyles}
//                                 menuPortalTarget={document.body}
//                                 name="leave_category"
//                                 value={convertOptionsForSoftSelect([form.leave_category])[0] || null}
//                                 onChange={(selected) => setPath("leave_category", selected?.value || "")}
//                                 options={convertOptionsForSoftSelect(["fixed", "experienced"], {
//                                     fixed: "Fixed",
//                                     experienced: "Experienced Based",
//                                 })}
//                                 isClearable={false}
//                                 placeholder="Select Category"
//                             />
//                             <Err name="leave_category" />
//                         </Field>

//                         <Field label="Leave Type">
//                             <SoftSelect
//                                 styles={customSelectStyles}
//                                 menuPortalTarget={document.body}
//                                 name="leave_type"
//                                 value={convertOptionsForSoftSelect([form.leave_type])[0] || null}
//                                 onChange={(selected) => setPath("leave_type", selected?.value || "")}
//                                 options={convertOptionsForSoftSelect(["paid", "unpaid"], {
//                                     paid: "Paid Leave",
//                                     unpaid: "Unpaid Leave",
//                                 })}
//                                 isClearable={false}
//                                 placeholder="Select Leave Type"
//                             />
//                             <Err name="leave_type" />
//                         </Field>
//                     </TwoColumnRow>

//                     <TwoColumnRow>
//                         <Field label="Credit Unit">
//                             <SoftSelect
//                                 styles={customSelectStyles}
//                                 menuPortalTarget={document.body}
//                                 name="leave_credit_unit"
//                                 value={convertOptionsForSoftSelect([form.leave_credit_unit])[0] || null}
//                                 onChange={(selected) => setPath("leave_credit_unit", selected?.value || "")}
//                                 options={convertOptionsForSoftSelect(["yearly", "monthly"], {
//                                     yearly: "Yearly",
//                                     monthly: "Monthly",
//                                 })}
//                                 isClearable={false}
//                                 placeholder="Select Credit Unit"
//                             />
//                             <Err name="leave_credit_unit" />
//                         </Field>

//                         <Field label="Credit Days">
//                             <SoftInput
//                                 type="number"
//                                 min={0}
//                                 name="leave_credit_days"
//                                 value={form.leave_credit_days}
//                                 onChange={(e) => setPath("leave_credit_days", Number(e.target.value))}
//                             />
//                             <div className="form-text">(Keep 0; engine accrues via rules)</div>
//                             <Err name="leave_credit_days" />
//                         </Field>
//                     </TwoColumnRow>

//                     <TwoColumnRow>
//                         <Field label="Reset Cycle">
//                             <SoftSelect
//                                 styles={customSelectStyles}
//                                 menuPortalTarget={document.body}
//                                 name="leave_reset_cycle"
//                                 value={convertOptionsForSoftSelect([form.leave_reset_cycle])[0] || null}
//                                 onChange={(selected) => setPath("leave_reset_cycle", selected?.value || "")}
//                                 options={convertOptionsForSoftSelect(["yearly", "monthly"], {
//                                     yearly: "Yearly",
//                                     monthly: "Monthly",
//                                 })}
//                                 isClearable={false}
//                                 placeholder="Select Reset Cycle"
//                             />
//                             <Err name="leave_reset_cycle" />
//                         </Field>

//                         <Field label="Description">
//                             <textarea
//                                 name="leave_description"
//                                 rows={2}
//                                 className="form-control"
//                                 value={form.leave_description}
//                                 onChange={(e) => setPath("leave_description", e.target.value)}
//                             />
//                             <Err name="leave_description" />
//                         </Field>
//                     </TwoColumnRow>
//                 </Section>

//                 {/* VISIBILITY RULES - 2 fields per row */}
//                 <Section title="Visibility Rules">
//                     <TwoColumnRow>
//                         <Field label="Start Anchor">
//                             <SoftSelect
//                                 styles={customSelectStyles}
//                                 menuPortalTarget={document.body}
//                                 name="leave_rules.visibility.start_anchor"
//                                 value={
//                                     convertOptionsForSoftSelect([form.leave_rules.visibility.start_anchor])[0] || null
//                                 }
//                                 onChange={(selected) =>
//                                     setPath("leave_rules.visibility.start_anchor", selected?.value || "")
//                                 }
//                                 options={convertOptionsForSoftSelect(["joining_date", "appointment_date"], {
//                                     joining_date: "Joining Date",
//                                     appointment_date: "Appointment Date",
//                                 })}
//                                 isClearable={false}
//                                 placeholder="Select Start Anchor"
//                             />
//                             <Err name="leave_rules.visibility.start_anchor" />
//                         </Field>

//                         <Field label="Start After (Days)">
//                             <SoftInput
//                                 type="number"
//                                 min={0}
//                                 name="leave_rules.visibility.start_after_days"
//                                 value={form.leave_rules.visibility.start_after_days}
//                                 onChange={(e) =>
//                                     setPath("leave_rules.visibility.start_after_days", Number(e.target.value))
//                                 }
//                             />
//                             <Err name="leave_rules.visibility.start_after_days" />
//                         </Field>
//                     </TwoColumnRow>

//                     <TwoColumnRow>
//                         <Field label="Start After (Months)">
//                             <SoftInput
//                                 type="number"
//                                 min={0}
//                                 name="leave_rules.visibility.start_after_months"
//                                 value={form.leave_rules.visibility.start_after_months}
//                                 onChange={(e) =>
//                                     setPath("leave_rules.visibility.start_after_months", Number(e.target.value))
//                                 }
//                             />
//                             <Err name="leave_rules.visibility.start_after_months" />
//                         </Field>
//                     </TwoColumnRow>
//                 </Section>

//                 {/* ACCRUAL RULES - 2 fields per row */}
//                 <Section title="Accrual Rules">
//                     <TwoColumnRow>
//                         <Field label="Pattern">
//                             <SoftSelect
//                                 styles={customSelectStyles}
//                                 menuPortalTarget={document.body}
//                                 name="leave_rules.accrual.pattern"
//                                 value={convertOptionsForSoftSelect([form.leave_rules.accrual.pattern])[0] || null}
//                                 onChange={(selected) =>
//                                     setPath("leave_rules.accrual.pattern", selected?.value || "")
//                                 }
//                                 options={convertOptionsForSoftSelect(
//                                     ["monthly_dayofmonth", "monthly_fixed", "odd_even_months"],
//                                     {
//                                         monthly_dayofmonth: "Monthly Day of Month",
//                                         monthly_fixed: "Monthly Fixed",
//                                         odd_even_months: "Odd/Even Months",
//                                     }
//                                 )}
//                                 isClearable={false}
//                                 placeholder="Select Accrual Pattern"
//                             />
//                             <Err name="leave_rules.accrual.pattern" />
//                         </Field>

//                         {form.leave_rules.accrual.pattern === "monthly_dayofmonth" && (
//                             <Field label="Frequency">
//                                 <SoftSelect
//                                     styles={customSelectStyles}
//                                     menuPortalTarget={document.body}
//                                     name="leave_rules.accrual.frequency"
//                                     value={
//                                         convertOptionsForSoftSelect([
//                                             form.leave_rules.accrual.frequency || "every_month",
//                                         ])[0] || null
//                                     }
//                                     onChange={(selected) =>
//                                         setPath("leave_rules.accrual.frequency", selected?.value || "")
//                                     }
//                                     options={convertOptionsForSoftSelect(
//                                         ["every_month", "odd_months", "even_months", "every_k_months"],
//                                         {
//                                             every_month: "Every Month",
//                                             odd_months: "Odd Months Only",
//                                             even_months: "Even Months Only",
//                                             every_k_months: "Every K Months",
//                                         }
//                                     )}
//                                     isClearable={false}
//                                     placeholder="Select Frequency"
//                                 />
//                                 <Err name="leave_rules.accrual.frequency" />
//                             </Field>
//                         )}
//                     </TwoColumnRow>

//                     {/* Monthly Day of Month Pattern Fields */}
//                     {form.leave_rules.accrual.pattern === "monthly_dayofmonth" && (
//                         <>
//                             {form.leave_rules.accrual.frequency === "every_k_months" && (
//                                 <TwoColumnRow>
//                                     <Field label="k (1–12)">
//                                         <SoftInput
//                                             type="number"
//                                             min={1}
//                                             max={12}
//                                             name="leave_rules.accrual.k"
//                                             value={form.leave_rules.accrual.k || ""}
//                                             onChange={(e) =>
//                                                 setPath(
//                                                     "leave_rules.accrual.k",
//                                                     e.target.value === "" ? null : Number(e.target.value)
//                                                 )
//                                             }
//                                         />
//                                         <Err name="leave_rules.accrual.k" />
//                                     </Field>

//                                     <Field label="phase (0..k-1)">
//                                         <SoftInput
//                                             type="number"
//                                             min={0}
//                                             name="leave_rules.accrual.phase"
//                                             value={form.leave_rules.accrual.phase || 0}
//                                             onChange={(e) => setPath("leave_rules.accrual.phase", Number(e.target.value))}
//                                         />
//                                     </Field>
//                                 </TwoColumnRow>
//                             )}

//                             <TwoColumnRow>
//                                 <Field label="Day (1–31)">
//                                     <SoftInput
//                                         type="number"
//                                         min={1}
//                                         max={31}
//                                         name="leave_rules.accrual.day"
//                                         value={form.leave_rules.accrual.day || ""}
//                                         onChange={(e) =>
//                                             setPath(
//                                                 "leave_rules.accrual.day",
//                                                 e.target.value === "" ? null : Number(e.target.value)
//                                             )
//                                         }
//                                     />
//                                     <div className="form-text">(Form-only; engine uses anchor DOM for SL/CL)</div>
//                                     <Err name="leave_rules.accrual.day" />
//                                 </Field>

//                                 <Field label="Credits per Event">
//                                     <SoftInput
//                                         type="number"
//                                         min={0}
//                                         step="0.5"
//                                         name="leave_rules.accrual.credits_per_event"
//                                         value={form.leave_rules.accrual.credits_per_event || 0}
//                                         onChange={(e) =>
//                                             setPath("leave_rules.accrual.credits_per_event", Number(e.target.value))
//                                         }
//                                     />
//                                     <Err name="leave_rules.accrual.credits_per_event" />
//                                 </Field>
//                             </TwoColumnRow>
//                         </>
//                     )}

//                     {/* Monthly Fixed Pattern Fields */}
//                     {form.leave_rules.accrual.pattern === "monthly_fixed" && (
//                         <TwoColumnRow>
//                             <Field label="Credits per Month">
//                                 <SoftInput
//                                     type="number"
//                                     min={0}
//                                     step={0.5}
//                                     name="leave_rules.accrual.credits_per_month"
//                                     value={form.leave_rules.accrual.credits_per_month || 0}
//                                     onChange={(e) =>
//                                         setPath("leave_rules.accrual.credits_per_month", Number(e.target.value))
//                                     }
//                                 />
//                                 <Err name="leave_rules.accrual.credits_per_month" />
//                             </Field>

//                             <Field label="Accrual Max per Year">
//                                 <SoftInput
//                                     type="number"
//                                     min={0}
//                                     step={0.5}
//                                     name="leave_rules.accrual.max_cap_per_year"
//                                     value={form.leave_rules.accrual.max_cap_per_year || ""}
//                                     onChange={(e) =>
//                                         setPath(
//                                             "leave_rules.accrual.max_cap_per_year",
//                                             e.target.value === "" ? null : Number(e.target.value)
//                                         )
//                                     }
//                                 />
//                             </Field>
//                         </TwoColumnRow>
//                     )}

//                     {/* Odd/Even Months Pattern Fields */}
//                     {form.leave_rules.accrual.pattern === "odd_even_months" && (
//                         <TwoColumnRow>
//                             <Field label="Frequency">
//                                 <SoftSelect
//                                     styles={customSelectStyles}
//                                     menuPortalTarget={document.body}
//                                     name="leave_rules.accrual.frequency"
//                                     value={
//                                         convertOptionsForSoftSelect([
//                                             form.leave_rules.accrual.frequency || "odd_months",
//                                         ])[0] || null
//                                     }
//                                     onChange={(selected) =>
//                                         setPath("leave_rules.accrual.frequency", selected?.value || "")
//                                     }
//                                     options={convertOptionsForSoftSelect(["odd_months", "even_months"], {
//                                         odd_months: "Odd Months Only",
//                                         even_months: "Even Months Only",
//                                     })}
//                                     isClearable={false}
//                                     placeholder="Select Frequency"
//                                 />
//                             </Field>

//                             <Field label="Credits per Event">
//                                 <SoftInput
//                                     type="number"
//                                     min={0}
//                                     step={0.5}
//                                     name="leave_rules.accrual.credits_per_event"
//                                     value={form.leave_rules.accrual.credits_per_event || 0}
//                                     onChange={(e) =>
//                                         setPath("leave_rules.accrual.credits_per_event", Number(e.target.value))
//                                     }
//                                 />
//                             </Field>
//                         </TwoColumnRow>
//                     )}
//                 </Section>

//                 {/* YEARLY LIMITS & RESET RULES - 2 fields per row */}
//                 <Section title="Yearly Limits & Reset Rules">
//                     <TwoColumnRow>
//                         <Field label="Yearly Max Cap">
//                             <SoftInput
//                                 type="number"
//                                 min={0}
//                                 step={0.5}
//                                 name="leave_rules.max_cap_per_year"
//                                 value={form.leave_rules.max_cap_per_year || 0}
//                                 onChange={(e) => setPath("leave_rules.max_cap_per_year", Number(e.target.value))}
//                             />
//                         </Field>

//                         <Field label="Carry Forward Enabled">
//                             <SoftSelect
//                                 styles={customSelectStyles}
//                                 menuPortalTarget={document.body}
//                                 name="leave_rules.carry_forward.enabled"
//                                 value={
//                                     convertOptionsForSoftSelect(
//                                         [form.leave_rules.carry_forward.enabled ? "true" : "false"],
//                                         {
//                                             false: "False",
//                                             true: "True",
//                                         }
//                                     )[0] || null
//                                 }
//                                 onChange={(selected) =>
//                                     setPath("leave_rules.carry_forward.enabled", selected?.value === "true")
//                                 }
//                                 options={convertOptionsForSoftSelect(["false", "true"], {
//                                     false: "False",
//                                     true: "True",
//                                 })}
//                                 isClearable={false}
//                                 placeholder="Select Status"
//                             />
//                         </Field>
//                     </TwoColumnRow>

//                     <TwoColumnRow>
//                         <Field label="Carry Forward Max Per Year">
//                             <SoftInput
//                                 type="number"
//                                 min={0}
//                                 step={0.5}
//                                 name="leave_rules.carry_forward.max_cap_per_year"
//                                 value={form.leave_rules.carry_forward.max_cap_per_year || 0}
//                                 onChange={(e) =>
//                                     setPath("leave_rules.carry_forward.max_cap_per_year", Number(e.target.value))
//                                 }
//                             />
//                         </Field>

//                         <Field label="Reset Mode">
//                             <SoftSelect
//                                 styles={customSelectStyles}
//                                 menuPortalTarget={document.body}
//                                 name="leave_rules.reset.mode"
//                                 value={
//                                     convertOptionsForSoftSelect([form.leave_rules.reset?.mode || "fixed_date"])[0] ||
//                                     null
//                                 }
//                                 onChange={(selected) => setPath("leave_rules.reset.mode", selected?.value || "")}
//                                 options={convertOptionsForSoftSelect(["fixed_date"], { fixed_date: "Fixed Date" })}
//                                 isClearable={false}
//                                 placeholder="Select Reset Mode"
//                             />
//                         </Field>
//                     </TwoColumnRow>

//                     <TwoColumnRow>
//                         <Field label="Reset Date (MM-DD)">
//                             <SoftInput
//                                 name="leave_rules.reset.date"
//                                 placeholder="12-31"
//                                 value={form.leave_rules.reset?.date || ""}
//                                 onChange={(e) => setPath("leave_rules.reset.date", e.target.value)}
//                             />
//                         </Field>
//                     </TwoColumnRow>
//                 </Section>

//                 {/* EMPLOYEE SELECTORS WITH API INTEGRATION - USING SOFTSELECT FOR MULTISELECT */}
//                 <Section title="Employee Selectors">
//                     {form.selectors.map((row, idx) => {
//                         const selectorOptions = getSelectorOptions(row.selector_type, idx);
//                         const softSelectOptions = convertSelectorOptionsForSoftSelect(selectorOptions);

//                         // Get current values for SoftSelect
//                         const currentValues = softSelectOptions.filter(
//                             (option) => Array.isArray(row.values) && row.values.includes(option.value)
//                         );

//                         return (
//                             <div key={idx} className="row g-2 mb-2 align-items-end">
//                                 <div className="col-md-2">
//                                     <label className="form-label small fw-bold">Mode</label>
//                                     <SoftSelect
//                                         styles={customSelectStyles}
//                                         menuPortalTarget={document.body}
//                                         value={
//                                             convertOptionsForSoftSelect([row.mode], {
//                                                 include: "Include",
//                                                 exclude: "Exclude",
//                                             })[0] || null
//                                         }
//                                         onChange={(selected) =>
//                                             handleSelectorChange(idx, "mode", selected?.value || "include")
//                                         }
//                                         options={convertOptionsForSoftSelect(["include", "exclude"], {
//                                             include: "Include",
//                                             exclude: "Exclude",
//                                         })}
//                                         isClearable={false}
//                                         placeholder="Select Mode"
//                                     />
//                                 </div>

//                                 <div className="col-md-3">
//                                     <label className="form-label small fw-bold">Selector Type</label>
//                                     <SoftSelect
//                                         styles={customSelectStyles}
//                                         menuPortalTarget={document.body}
//                                         value={
//                                             convertOptionsForSoftSelect([row.selector_type], {
//                                                 branch: "Branch",
//                                                 shift: "Shift",
//                                                 department: "Department",
//                                                 designation: "Designation",
//                                                 role: "Role",
//                                                 user: "User",
//                                             })[0] || null
//                                         }
//                                         onChange={(selected) =>
//                                             handleSelectorChange(idx, "selector_type", selected?.value || "branch")
//                                         }
//                                         options={convertOptionsForSoftSelect(
//                                             ["branch", "shift", "department", "designation", "role", "user"],
//                                             {
//                                                 branch: "Branch",
//                                                 shift: "Shift",
//                                                 department: "Department",
//                                                 designation: "Designation",
//                                                 role: "Role",
//                                                 user: "User",
//                                             }
//                                         )}
//                                         isClearable={false}
//                                         placeholder="Select Type"
//                                     />
//                                 </div>

//                                 <div className="col-md-5">
//                                     <label className="form-label small fw-bold">Values</label>
//                                     <SoftSelect
//                                         styles={customSelectStyles}
//                                         menuPortalTarget={document.body}
//                                         isMulti
//                                         value={currentValues}
//                                         onChange={(selected) => handleSelectorChange(idx, "values", selected || [])}
//                                         options={softSelectOptions}
//                                         placeholder={`Select ${row.selector_type} values`}
//                                         closeMenuOnSelect={false}
//                                     />
//                                     <div className="form-text">
//                                         {row.selector_type === "user" && (
//                                             <span>({filteredUsers.length} users available)</span>
//                                         )}
//                                     </div>
//                                 </div>

//                                 <div className="col-md-2">
//                                     <SoftButton
//                                         type="button"
//                                         color="error"
//                                         onClick={() => removeSelector(idx)}
//                                         variant="gradient"
//                                         className="w-100"
//                                     >
//                                         Remove
//                                     </SoftButton>
//                                 </div>
//                             </div>
//                         );
//                     })}

//                     <SoftButton type="button" color="info" onClick={addSelector} className="mt-2">
//                         + Add Selector
//                     </SoftButton>
//                 </Section>

//                 {/* ACTIONS */}
//                 <div className="mt-4 d-flex justify-content-end gap-2">
//                     {onCancel && (
//                         <SoftButton
//                             type="button"
//                             color="secondary"
//                             onClick={handleCancel}
//                             disabled={loading}
//                             className="px-4"
//                         >
//                             Cancel
//                         </SoftButton>
//                     )}
//                     <SoftButton
//                         type="button"
//                         color="warning"
//                         onClick={handleReset}
//                         disabled={loading}
//                         className="px-4"
//                     >
//                         Reset
//                     </SoftButton>
//                     <SoftButton type="submit" color="info" disabled={loading} className="px-4">
//                         {loading
//                             ? isEditMode
//                                 ? "Updating..."
//                                 : "Creating..."
//                             : isEditMode
//                                 ? "Update Policy"
//                                 : "Create Policy"}
//                     </SoftButton>
//                 </div>
//             </SoftBox>
//         </Card>
//     );
// }

// CreateLeavePolicyForm.propTypes = {
//     policyId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
//     onSuccess: PropTypes.func,
//     onCancel: PropTypes.func,
// };

// CreateLeavePolicyForm.defaultProps = {
//     policyId: null,
//     onSuccess: null,
//     onCancel: null,
// };

// const Section = ({ title, children }) => (
//     <SoftBox mb={3} p={3} className="border rounded-3 bg-white">
//         <SoftTypography variant="h6" fontWeight="bold" className="mb-3 text-primary">
//             {title}
//         </SoftTypography>
//         {children}
//     </SoftBox>
// );
// Section.propTypes = {
//     title: PropTypes.string.isRequired,
//     children: PropTypes.node,
// };

// const TwoColumnRow = ({ children }) => (
//     <div className="row g-3 mb-3">
//         {React.Children.map(children, (child, index) => (
//             <div className="col-md-6 col-12" key={index}>
//                 {child}
//             </div>
//         ))}
//     </div>
// );
// TwoColumnRow.propTypes = {
//     children: PropTypes.node,
// };

// const Field = ({ label, children }) => (
//     <div>
//         <label className="form-label small fw-bold text-dark mb-2">{label}</label>
//         <div>{children}</div>
//     </div>
// );
// Field.propTypes = {
//     label: PropTypes.string.isRequired,
//     children: PropTypes.node,
// };


import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftInput from "components/SoftInput";
import SoftButton from "components/SoftButton";
import SoftSnackbar from "components/SoftSnackbar";
import SoftSelect from "components/SoftSelect";
import Switch from "@mui/material/Switch";
import { API_URL } from "config";
import { Card } from "@mui/material";
import {
    fetchBranches,
    fetchShifts,
    fetchDepartments,
    fetchDesignations,
    fetchRoles,
} from "api/interviewuserdata";
import { getUsers } from "api/users";

// --- Initial Form (Credit Days & Unit removed) ---
const initialForm = {
    leave_name: "",
    leave_code: "",
    leave_category: "",
    leave_type: "",
    leave_reset_cycle: "yearly",
    leave_description: "",
    leave_rules: {
        visibility: {
            start_anchor: "",
            start_after_days: 0,
            credit_per_event: 0,
            max_events_per_year: 0,
            next_event_after_days: 0,
            dependency: {
                enabled: false,
                policy_ids: [],
            },
        },
        yearly_limits: {
            max_cap_per_year: 0,
            carry_forward_enabled: false,
            carry_forward_max: 0,
            reset: {
                mode: "fixed_date",
                date: "12-31",
            },
        },
    },
    selectors: [{ mode: "include", selector_type: "branch", values: ["ALL"] }],
};

const customSelectStyles = {
    menu: (provided) => ({ ...provided, zIndex: 9999 }),
    menuPortal: (provided) => ({ ...provided, zIndex: 9999 }),
    container: (provided) => ({ ...provided, zIndex: 9998 }),
    control: (provided) => ({ ...provided, zIndex: 1 }),
};

export default function CreateLeavePolicyForm({ policyId, onSuccess, onCancel }) {
    const [form, setForm] = useState(initialForm);
    const [loading, setLoading] = useState(false);
    const [snack, setSnack] = useState({ open: false, color: "success", message: "" });
    const [errors, setErrors] = useState(null);
    const [isEditMode, setIsEditMode] = useState(false);

    // API data states
    const [branches, setBranches] = useState([]);
    const [shifts, setShifts] = useState([]);
    const [departments, setDepartments] = useState([]);
    const [designations, setDesignations] = useState([]);
    const [roles, setRoles] = useState([]);
    const [users, setUsers] = useState([]);
    const [filteredShifts, setFilteredShifts] = useState([]);
    const [filteredUsers, setFilteredUsers] = useState([]);
    const [allPolicies, setAllPolicies] = useState([]);
    const [loadingPolicies, setLoadingPolicies] = useState(false);

    // Helpers
    const normalizeUsersArray = (resp) => {
        if (!resp) return [];
        if (Array.isArray(resp)) return resp;
        if (Array.isArray(resp.data)) return resp.data;
        if (Array.isArray(resp.users)) return resp.users;
        return [];
    };

    const convertOptionsForSoftSelect = (optionsArray, labels = {}) => {
        return optionsArray.map((option) => ({
            value: option,
            label: labels[option] || option,
        }));
    };

    const convertSelectorOptionsForSoftSelect = (optionsArray) => {
        return optionsArray.map((option) => ({
            value: option.id,
            label: option.name,
        }));
    };

    // Fetch all leave policies for dependency dropdown
    const fetchAllPolicies = async () => {
        setLoadingPolicies(true);
        try {
            const response = await fetchWithAuth(`${API_URL}/leave-policies`);
            let policiesList = [];
            if (Array.isArray(response)) policiesList = response;
            else if (response.data && Array.isArray(response.data)) policiesList = response.data;
            setAllPolicies(policiesList);
        } catch (error) {
            console.error("Error fetching all policies:", error);
            setAllPolicies([
                { id: 14, leave_name: "Sick Leave", leave_code: "SL" },
                { id: 15, leave_name: "Earned Leave", leave_code: "EL" },
            ]);
        } finally {
            setLoadingPolicies(false);
        }
    };

    const getAllUsers = async () => {
        try {
            let allUsers = [];
            let currentPage = 1;
            let hasMore = true;
            const perPage = 1000;
            while (hasMore) {
                const usersData = await getUsers(currentPage, perPage);
                const normalized = normalizeUsersArray(usersData);
                if (normalized.length > 0) {
                    allUsers = [...allUsers, ...normalized];
                    currentPage++;
                    if (normalized.length < perPage) hasMore = false;
                } else {
                    hasMore = false;
                }
            }
            return allUsers;
        } catch (error) {
            console.error(error);
            return [];
        }
    };

    useEffect(() => {
        const loadInitialData = async () => {
            try {
                const [branchesData, shiftsData, deptsData, designationsData, rolesData, usersData] =
                    await Promise.all([
                        fetchBranches(),
                        fetchShifts(),
                        fetchDepartments(),
                        fetchDesignations(),
                        fetchRoles(),
                        getAllUsers(),
                    ]);
                setBranches(Array.isArray(branchesData) ? branchesData : []);
                setShifts(Array.isArray(shiftsData) ? shiftsData : []);
                setFilteredShifts(Array.isArray(shiftsData) ? shiftsData : []);
                setDepartments(Array.isArray(deptsData) ? deptsData : []);
                setDesignations(Array.isArray(designationsData) ? designationsData : []);
                setRoles(Array.isArray(rolesData) ? rolesData : []);
                setUsers(usersData);
                setFilteredUsers(usersData);
            } catch (error) {
                console.error(error);
            }
        };
        loadInitialData();
        fetchAllPolicies();
    }, []);

    useEffect(() => {
        if (policyId) {
            setIsEditMode(true);
            fetchPolicyData(policyId);
        } else {
            setIsEditMode(false);
            setForm(initialForm);
        }
    }, [policyId]);

    const fetchWithAuth = async (url, options = {}) => {
        const token = localStorage.getItem("authToken");
        const res = await fetch(url, {
            ...options,
            headers: {
                ...(options.headers || {}),
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
                Accept: "application/json",
            },
        });
        const data = await res.json().catch(() => ({}));
        if (!res.ok) throw { status: res.status, data };
        return data;
    };

    const fetchPolicyData = async (id) => {
        setLoading(true);
        try {
            const data = await fetchWithAuth(`${API_URL}/leave-policies/${id}`);
            const mergedRules = {
                visibility: {
                    ...initialForm.leave_rules.visibility,
                    ...(data.leave_rules?.visibility || {}),
                    dependency: {
                        enabled: data.leave_rules?.visibility?.dependency?.enabled || false,
                        policy_ids: data.leave_rules?.visibility?.dependency?.policy_ids || [],
                    },
                },
                yearly_limits: {
                    ...initialForm.leave_rules.yearly_limits,
                    ...(data.leave_rules?.yearly_limits || {}),
                    reset: {
                        ...initialForm.leave_rules.yearly_limits.reset,
                        ...(data.leave_rules?.yearly_limits?.reset || {}),
                    },
                },
            };
            setForm({
                leave_name: data.leave_name || "",
                leave_code: data.leave_code || "",
                leave_category: data.leave_category || "fixed",
                leave_type: data.leave_type || "paid",
                leave_reset_cycle: data.leave_reset_cycle || "yearly",
                leave_description: data.leave_description || "",
                leave_rules: mergedRules,
                selectors: data.selectors || initialForm.selectors,
            });
            if (data.selectors) fetchUsersBySelectors(data.selectors);
            setSnack({ open: true, color: "success", message: "Policy loaded." });
        } catch (error) {
            console.error(error);
            setSnack({ open: true, color: "error", message: "Failed to load policy." });
        } finally {
            setLoading(false);
        }
    };

    const fetchUsersBySelectors = async (selectors) => {
        try {
            const params = new URLSearchParams();
            const buckets = { branch: [], shift: [], department: [], designation: [], role: [], user: [] };
            selectors.forEach((s) => {
                if (!Array.isArray(s.values) || s.values.includes("ALL")) return;
                const key = s.selector_type;
                if (buckets[key]) s.values.forEach((v) => buckets[key].push(String(v)));
            });
            if (buckets.branch.length) params.append("branch_ids", buckets.branch.join(","));
            if (buckets.shift.length) params.append("shift_ids", buckets.shift.join(","));
            if (buckets.department.length) params.append("department_ids", buckets.department.join(","));
            if (buckets.designation.length) params.append("designation_ids", buckets.designation.join(","));
            if (buckets.role.length) params.append("role_ids", buckets.role.join(","));
            if (buckets.user.length) params.append("user_ids", buckets.user.join(","));
            params.append("per_page", "1000");
            const res = await fetchWithAuth(`${API_URL}/users?${params.toString()}`);
            const normalized = normalizeUsersArray(res);
            setUsers(normalized);
            setFilteredUsers(normalized);
        } catch (err) {
            console.error(err);
            setFilteredUsers([]);
        }
    };

    const filterUsersBySelectorsClient = (selectors) => {
        let filtered = [...users];
        selectors.forEach((sel) => {
            if (!Array.isArray(sel.values) || sel.values.includes("ALL")) return;
            const key = sel.selector_type;
            filtered = filtered.filter((user) => sel.values.includes(String(user[`${key}_id`] || user.id)));
        });
        setFilteredUsers(filtered);
    };

    const setPath = (path, value) => {
        setForm((prev) => {
            const copy = structuredClone(prev);
            const keys = path.split(".");
            let node = copy;
            for (let i = 0; i < keys.length - 1; i++) {
                const k = keys[i];
                if (node[k] == null || typeof node[k] !== "object") node[k] = {};
                node = node[k];
            }
            node[keys.at(-1)] = value;
            return copy;
        });
    };

    // Selectors
    const addSelector = () => {
        setForm((prev) => ({
            ...prev,
            selectors: [...prev.selectors, { mode: "include", selector_type: "branch", values: ["ALL"] }],
        }));
    };

    const removeSelector = (idx) => {
        setForm((prev) => {
            const updated = prev.selectors.filter((_, i) => i !== idx);
            fetchUsersBySelectors(updated);
            return { ...prev, selectors: updated };
        });
    };

    const handleSelectorChange = async (idx, field, value) => {
        const updatedSelectors = [...form.selectors];
        if (field === "selector_type") {
            updatedSelectors[idx][field] = value;
            updatedSelectors[idx].values = ["ALL"];
        } else if (field === "values") {
            const selectedValues = Array.isArray(value)
                ? value.map((item) => item.value)
                : [value?.value] || ["ALL"];
            updatedSelectors[idx][field] = selectedValues;
            if (updatedSelectors[idx].selector_type === "branch") {
                const branchVal = selectedValues[0];
                if (branchVal && branchVal !== "ALL") {
                    try {
                        const shiftData = await fetchWithAuth(`${API_URL}/shifts?branch_id=${branchVal}`);
                        setFilteredShifts(Array.isArray(shiftData) ? shiftData : shiftData?.data ?? []);
                    } catch (err) {
                        setFilteredShifts([]);
                    }
                } else {
                    setFilteredShifts(shifts);
                }
            }
        } else {
            updatedSelectors[idx][field] = value;
        }
        setForm((prev) => ({ ...prev, selectors: updatedSelectors }));
        fetchUsersBySelectors(updatedSelectors);
        filterUsersBySelectorsClient(updatedSelectors);
    };

    const getSelectorOptions = (selectorType) => {
        const safeBranches = branches.map(b => ({ id: String(b.id), name: b.name }));
        const safeFilteredShifts = filteredShifts.map(s => ({ id: String(s.id), name: s.name }));
        const safeDepartments = departments.map(d => ({ id: String(d.id), name: d.name }));
        const safeDesignations = designations.map(d => ({ id: String(d.id), name: d.name }));
        const safeRoles = roles.map(r => ({ id: String(r.id), name: r.name }));
        const safeFilteredUsers = filteredUsers.map(u => ({ id: String(u.id), name: `${u.first_name || ""} ${u.last_name || ""}`.trim() || u.name || `User ${u.id}` }));
        switch (selectorType) {
            case "branch": return [{ id: "ALL", name: "All Branches" }, ...safeBranches];
            case "shift": return [{ id: "ALL", name: "All Shifts" }, ...safeFilteredShifts];
            case "department": return [{ id: "ALL", name: "All Departments" }, ...safeDepartments];
            case "designation": return [{ id: "ALL", name: "All Designations" }, ...safeDesignations];
            case "role": return [{ id: "ALL", name: "All Roles" }, ...safeRoles];
            case "user": return [{ id: "ALL", name: "All Users" }, ...safeFilteredUsers];
            default: return [{ id: "ALL", name: "All" }];
        }
    };

    const onSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setErrors(null);

        if (form.leave_rules.visibility.dependency.enabled &&
            (!form.leave_rules.visibility.dependency.policy_ids || form.leave_rules.visibility.dependency.policy_ids.length === 0)) {
            setErrors({ "leave_rules.visibility.dependency.policy_ids": ["Please select at least one dependent policy."] });
            setSnack({ open: true, color: "error", message: "Please select at least one dependent policy." });
            setLoading(false);
            return;
        }

        try {
            let data;
            if (isEditMode) {
                data = await fetchWithAuth(`${API_URL}/leave-policies/${policyId}`, {
                    method: "PUT",
                    body: JSON.stringify(form),
                });
                setSnack({ open: true, color: "success", message: "Policy updated." });
            } else {
                data = await fetchWithAuth(`${API_URL}/leave-policies`, {
                    method: "POST",
                    body: JSON.stringify(form),
                });
                setSnack({ open: true, color: "success", message: "Policy created." });
            }
            if (onSuccess) onSuccess(data);
        } catch (err) {
            const errs = err?.data?.errors || { _error: [err?.data?.message || "Request failed"] };
            setErrors(errs);
            setSnack({ open: true, color: "error", message: isEditMode ? "Update failed." : "Creation failed." });
        } finally {
            setLoading(false);
        }
    };

    const handleReset = () => {
        if (isEditMode && policyId) fetchPolicyData(policyId);
        else setForm(initialForm);
        setErrors(null);
    };

    const Err = ({ name }) => errors?.[name] ? <div className="text-danger small mt-1">{errors[name].map((m, i) => <div key={i}>• {m}</div>)}</div> : null;
    Err.propTypes = { name: PropTypes.string.isRequired };

    return (
        <Card className="p-3 mb-3 bg-light">
            <SoftTypography variant="h5" fontWeight="medium" className="mb-3">
                {isEditMode ? "Edit Leave Policy" : "Create Leave Policy"}
            </SoftTypography>
            <SoftSnackbar color={snack.color} icon="notifications" title="Leave Policy" content={snack.message} open={snack.open} close={() => setSnack({ ...snack, open: false })} time={3000} />
            <SoftBox component="form" onSubmit={onSubmit} autoComplete="off" noValidate>
                {/* Basic Information - Credit Days/Unit removed */}
                <Section title="Basic Information">
                    <TwoColumnRow>
                        <Field label="Leave Name"><SoftInput name="leave_name" value={form.leave_name} onChange={(e) => setPath("leave_name", e.target.value)} required /><Err name="leave_name" /></Field>
                        <Field label="Leave Code"><SoftInput name="leave_code" value={form.leave_code} onChange={(e) => setPath("leave_code", e.target.value)} required /><Err name="leave_code" /></Field>
                    </TwoColumnRow>
                    <TwoColumnRow>
                        <Field label="Category"><SoftSelect styles={customSelectStyles} menuPortalTarget={document.body} value={convertOptionsForSoftSelect([form.leave_category])[0]} onChange={(selected) => setPath("leave_category", selected?.value || "")} options={convertOptionsForSoftSelect(["fixed", "experienced"], { fixed: "Fixed", experienced: "Experienced Based" })} isClearable={false} /><Err name="leave_category" /></Field>
                        <Field label="Leave Type"><SoftSelect styles={customSelectStyles} menuPortalTarget={document.body} value={convertOptionsForSoftSelect([form.leave_type])[0]} onChange={(selected) => setPath("leave_type", selected?.value || "")} options={convertOptionsForSoftSelect(["paid", "unpaid"], { paid: "Paid", unpaid: "Unpaid" })} isClearable={false} /><Err name="leave_type" /></Field>
                    </TwoColumnRow>
                    <TwoColumnRow>
                        <Field label="Reset Cycle"><SoftSelect styles={customSelectStyles} menuPortalTarget={document.body} value={convertOptionsForSoftSelect([form.leave_reset_cycle])[0]} onChange={(selected) => setPath("leave_reset_cycle", selected?.value || "")} options={convertOptionsForSoftSelect(["yearly", "monthly"])} isClearable={false} /><Err name="leave_reset_cycle" /></Field>
                        <Field label="Description"><textarea rows={2} className="form-control" value={form.leave_description} onChange={(e) => setPath("leave_description", e.target.value)} /><Err name="leave_description" /></Field>
                    </TwoColumnRow>
                </Section>

                {/* Visibility Rules */}
                <Section title="Visibility Rules (Accrual & Eligibility)">
                    <TwoColumnRow>
                        <Field label="Start Anchor"><SoftSelect styles={customSelectStyles} menuPortalTarget={document.body} value={convertOptionsForSoftSelect([form.leave_rules.visibility.start_anchor])[0]} onChange={(selected) => setPath("leave_rules.visibility.start_anchor", selected?.value || "")} options={convertOptionsForSoftSelect(["joining_date", "appointment_date"], { joining_date: "Joining Date", appointment_date: "Appointment Date" })} isClearable={false} /><Err name="leave_rules.visibility.start_anchor" /></Field>
                        <Field label="Start After (Days)"><SoftInput type="number" min={0} value={form.leave_rules.visibility.start_after_days} onChange={(e) => setPath("leave_rules.visibility.start_after_days", Number(e.target.value))} /><Err name="leave_rules.visibility.start_after_days" /></Field>
                    </TwoColumnRow>
                    <TwoColumnRow>
                        <Field label="Credit per Event"><SoftInput type="number" min={0} step={0.5} value={form.leave_rules.visibility.credit_per_event} onChange={(e) => setPath("leave_rules.visibility.credit_per_event", Number(e.target.value))} /><div className="form-text">How many leaves credited each event</div><Err name="leave_rules.visibility.credit_per_event" /></Field>
                        <Field label="Max Events per Year"><SoftInput type="number" min={0} value={form.leave_rules.visibility.max_events_per_year} onChange={(e) => setPath("leave_rules.visibility.max_events_per_year", Number(e.target.value))} /><div className="form-text">Limit number of accrual events in a year</div><Err name="leave_rules.visibility.max_events_per_year" /></Field>
                    </TwoColumnRow>
                    <TwoColumnRow>
                        <Field label="Next Event After (Days)"><SoftInput type="number" min={0} value={form.leave_rules.visibility.next_event_after_days} onChange={(e) => setPath("leave_rules.visibility.next_event_after_days", Number(e.target.value))} /><div className="form-text">Gap between consecutive events</div><Err name="leave_rules.visibility.next_event_after_days" /></Field>
                    </TwoColumnRow>

                    {/* Dependency Toggle & Dropdown */}
                    <div className="mt-4 pt-3 border-top">
                        <div className="d-flex align-items-center mb-3">
                            <div className="me-3">
                                <Switch
                                    checked={form.leave_rules.visibility.dependency.enabled}
                                    onChange={(e) => setPath("leave_rules.visibility.dependency.enabled", e.target.checked)}
                                    color="primary"
                                />
                            </div>
                            <SoftTypography variant="body2" fontWeight="medium">
                                Enable Dependency on Other Policies
                            </SoftTypography>
                            <div className="text-muted small ms-2">
                                (If enabled, this policy will be available only after the selected policies are assigned)
                            </div>
                        </div>

                        {form.leave_rules.visibility.dependency.enabled && (
                            <TwoColumnRow>
                                <Field label="Select Dependent Policies">
                                    <SoftSelect
                                        styles={customSelectStyles}
                                        menuPortalTarget={document.body}
                                        isMulti
                                        placeholder={loadingPolicies ? "Loading policies..." : "Search or select policies..."}
                                        isLoading={loadingPolicies}
                                        // value={allPolicies
                                        //     .filter(p => form.leave_rules.visibility.dependency.policy_ids.includes(p.id))
                                        //     .map(p => ({ value: p.id, label: `${p.leave_name} (${p.leave_code})` }))}
                                        value={allPolicies
                                            .filter(p => {
                                                // Convert both to string for comparison
                                                const policyIdStr = String(p.id);
                                                return form.leave_rules.visibility.dependency.policy_ids.some(id => String(id) === policyIdStr);
                                            })
                                            .map(p => ({ value: p.id, label: `${p.leave_name} (${p.leave_code})` }))}
                                        onChange={(selected) => {
                                            const selectedIds = selected ? selected.map(item => item.value) : [];
                                            setPath("leave_rules.visibility.dependency.policy_ids", selectedIds);
                                        }}
                                        options={allPolicies.map(policy => ({
                                            value: policy.id,
                                            label: `${policy.leave_name} (${policy.leave_code})`
                                        }))}
                                        closeMenuOnSelect={false}
                                    />
                                    <div className="form-text">
                                        These policies must be assigned to the employee before this policy becomes visible.
                                    </div>
                                    <Err name="leave_rules.visibility.dependency.policy_ids" />
                                </Field>
                            </TwoColumnRow>
                        )}
                    </div>
                </Section>

                {/* Yearly Limits & Reset */}
                <Section title="Yearly Limits & Reset Rules">
                    <TwoColumnRow>
                        <Field label="Yearly Max Cap"><SoftInput type="number" min={0} step={0.5} value={form.leave_rules.yearly_limits.max_cap_per_year} onChange={(e) => setPath("leave_rules.yearly_limits.max_cap_per_year", Number(e.target.value))} /><div className="form-text">Maximum leaves that can be held at any time</div></Field>
                        <Field label="Carry Forward Enabled"><SoftSelect styles={customSelectStyles} menuPortalTarget={document.body} value={convertOptionsForSoftSelect([form.leave_rules.yearly_limits.carry_forward_enabled ? "true" : "false"], { false: "False", true: "True" })[0]} onChange={(selected) => setPath("leave_rules.yearly_limits.carry_forward_enabled", selected?.value === "true")} options={convertOptionsForSoftSelect(["false", "true"], { false: "False", true: "True" })} isClearable={false} /></Field>
                    </TwoColumnRow>
                    <TwoColumnRow>
                        <Field label="Carry Forward Max"><SoftInput type="number" min={0} step={0.5} value={form.leave_rules.yearly_limits.carry_forward_max} onChange={(e) => setPath("leave_rules.yearly_limits.carry_forward_max", Number(e.target.value))} /><div className="form-text">Max leaves that can be carried forward</div></Field>
                        <Field label="Reset Mode"><SoftSelect styles={customSelectStyles} menuPortalTarget={document.body} value={convertOptionsForSoftSelect([form.leave_rules.yearly_limits.reset.mode])[0]} onChange={(selected) => setPath("leave_rules.yearly_limits.reset.mode", selected?.value || "fixed_date")} options={convertOptionsForSoftSelect(["fixed_date"], { fixed_date: "Fixed Date" })} isClearable={false} /></Field>
                    </TwoColumnRow>
                    <TwoColumnRow>
                        <Field label="Reset Date (MM-DD)"><SoftInput placeholder="12-31" value={form.leave_rules.yearly_limits.reset.date} onChange={(e) => setPath("leave_rules.yearly_limits.reset.date", e.target.value)} /><div className="form-text">Example: 12-31 for year end</div></Field>
                    </TwoColumnRow>
                </Section>

                {/* Employee Selectors */}
                <Section title="Employee Selectors">
                    {form.selectors.map((row, idx) => {
                        const options = getSelectorOptions(row.selector_type);
                        const softOpts = convertSelectorOptionsForSoftSelect(options);
                        const currentValues = softOpts.filter(opt => Array.isArray(row.values) && row.values.includes(opt.value));
                        return (
                            <div key={idx} className="row g-2 mb-2 align-items-end">
                                <div className="col-md-2"><label className="form-label small fw-bold">Mode</label><SoftSelect styles={customSelectStyles} menuPortalTarget={document.body} value={convertOptionsForSoftSelect([row.mode], { include: "Include", exclude: "Exclude" })[0]} onChange={(selected) => handleSelectorChange(idx, "mode", selected?.value || "include")} options={convertOptionsForSoftSelect(["include", "exclude"])} isClearable={false} /></div>
                                <div className="col-md-3"><label className="form-label small fw-bold">Type</label><SoftSelect styles={customSelectStyles} menuPortalTarget={document.body} value={convertOptionsForSoftSelect([row.selector_type], { branch: "Branch", shift: "Shift", department: "Department", designation: "Designation", role: "Role", user: "User" })[0]} onChange={(selected) => handleSelectorChange(idx, "selector_type", selected?.value || "branch")} options={convertOptionsForSoftSelect(["branch", "shift", "department", "designation", "role", "user"])} isClearable={false} /></div>
                                <div className="col-md-5"><label className="form-label small fw-bold">Values</label><SoftSelect styles={customSelectStyles} menuPortalTarget={document.body} isMulti value={currentValues} onChange={(selected) => handleSelectorChange(idx, "values", selected || [])} options={softOpts} placeholder={`Select ${row.selector_type} values`} closeMenuOnSelect={false} /><div className="form-text">{row.selector_type === "user" && `(${filteredUsers.length} users)`}</div></div>
                                <div className="col-md-2"><SoftButton type="button" color="error" onClick={() => removeSelector(idx)} variant="gradient" className="w-100">Remove</SoftButton></div>
                            </div>
                        );
                    })}
                    <SoftButton type="button" color="info" onClick={addSelector} className="mt-2">+ Add Selector</SoftButton>
                </Section>

                {/* Action Buttons */}
                <div className="mt-4 d-flex justify-content-end gap-2">
                    {onCancel && <SoftButton type="button" color="secondary" onClick={onCancel} disabled={loading}>Cancel</SoftButton>}
                    <SoftButton type="button" color="warning" onClick={handleReset} disabled={loading}>Reset</SoftButton>
                    <SoftButton type="submit" color="info" disabled={loading}>{loading ? (isEditMode ? "Updating..." : "Creating...") : (isEditMode ? "Update Policy" : "Create Policy")}</SoftButton>
                </div>
            </SoftBox>
        </Card>
    );
}

CreateLeavePolicyForm.propTypes = {
    policyId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    onSuccess: PropTypes.func,
    onCancel: PropTypes.func,
};

CreateLeavePolicyForm.defaultProps = {
    policyId: null,
    onSuccess: null,
    onCancel: null,
};

const Section = ({ title, children }) => (
    <SoftBox mb={3} p={3} className="border rounded-3 bg-white">
        <SoftTypography variant="h6" fontWeight="bold" className="mb-3 text-primary">{title}</SoftTypography>
        {children}
    </SoftBox>
);
Section.propTypes = { title: PropTypes.string.isRequired, children: PropTypes.node };

const TwoColumnRow = ({ children }) => (
    <div className="row g-3 mb-3">
        {React.Children.map(children, (child, i) => <div className="col-md-6 col-12" key={i}>{child}</div>)}
    </div>
);
TwoColumnRow.propTypes = { children: PropTypes.node };

const Field = ({ label, children }) => (
    <div><label className="form-label small fw-bold text-dark mb-2">{label}</label><div>{children}</div></div>
);
Field.propTypes = { label: PropTypes.string.isRequired, children: PropTypes.node };